<template>
  <div class="card-container">
    <div class="card-item-header">
      <i :class="icon" class="green-arrow stats-icon fa-3x"></i>
      <h3>{{ title }}</h3>
    </div>

    <p v-if="description">{{ description }}</p>

    <div class="card-item-footer">
      <hr>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
  .card-container {
    flex: 1 1 calc(25% - 2rem);
    min-width: 18rem;
    max-width: calc(25% - 2rem);

    border-top: 0.5rem solid #ffc20e;
    background: #ffffff;
    -webkit-box-shadow: 0px 4px 70px -18px #707070;
    box-shadow: 0px 4px 70px -18px #707070;
    margin-bottom: 1.875rem;
    padding: 1.5rem;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    text-align: center;

    p {
      flex: 1;

      display: flex;
      align-items: center
    }

    .card-item-header {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .card-item-header,
    .card-item-footer {
      width: 100%;
    }
  }
</style>